import React from "react";
import { useLocation } from "react-router-dom";
import { useMeeting } from "../../hooks/useMeeting";
import ReunionPage from "../../pages/ReunionPage";
import MeetingMiniBar from "./MeetingMiniBar";

export default function MeetingOverlay() {
  const { isMeetingActive } = useMeeting();
  const location = useLocation();
  const isFullscreen = location.pathname === "/reunion-start";

  if (!isMeetingActive) return null;

  return (
    <>
      {/* Toujours monté tant que la réunion est active.
          On ne démonte JAMAIS ReunionPage — on cache juste le contenu avec CSS
          pour que les flux WebRTC (video tracks, producers) restent actifs. */}
      <div style={{ display: isFullscreen ? "" : "none" }}>
        <ReunionPage />
      </div>
      {!isFullscreen && <MeetingMiniBar />}
    </>
  );
}
